"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  id: null,
  portalId: null,
  name: null,
  created: null,
  deletedAt: null,
  createdById: null
}, 'BrandDomain');

exports.default = _default;
module.exports = exports.default;